import { Box, Typography } from "@mui/material";
import useColors from "../../../../../../../api/hooks/useColors";

const CvesChartLegend = () => {
  const colors = useColors();
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          display: "flex",
          gap: 1,
          alignItems: "center",
          color: colors.text_secondary,
        }}
      >
        <Box
          sx={{
            display: "flex",
            gap: 1,
            width: "10px",
            height: "10px",
            background: colors.cve_critical,
            borderRadius: "3px",
          }}
        />
        <Typography variant="caption">Critical</Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          gap: 1,
          alignItems: "center",
          color: colors.text_secondary,
        }}
      >
        <Box
          sx={{
            display: "flex",
            gap: 1,
            width: "10px",
            height: "10px",
            background: colors.cve_high,
            borderRadius: "3px",
          }}
        />
        <Typography variant="caption">High</Typography>
      </Box>
    </Box>
  );
};

export default CvesChartLegend;
